import { AxiosRequestConfig } from "axios";
import { CohesiveAPIClient } from "../../client";
import { route } from "../../utils";
import {
  CreateResourceTagRequest,
  RESOURCE_TAG_FAVORITE,
  ResourceTagResourceType,
  ResourceTagResponse,
} from "./types";

export * from "./types";

const ENDPOINTS = {
  CREATE: "/api/v2/org/:organization_id/user/:user_id/resource-tags",
  DELETE:
    "/api/v2/org/:organization_id/user/:user_id/resource-tags/:resource_type/:resource_id/:tag_key",
};

export class ResourceTagsAPI {
  constructor(private client: CohesiveAPIClient) {}

  /** Tag (favorite) a resource for the current user. Idempotent. */
  async create(
    data: CreateResourceTagRequest,
    config?: AxiosRequestConfig,
  ): Promise<ResourceTagResponse> {
    const organizationId = await this.client.getOrgID();
    const userId = await this.client.getUserID();

    const response = await this.client.axios.post<ResourceTagResponse>(
      route(ENDPOINTS.CREATE, {
        organization_id: organizationId,
        user_id: userId,
      }),
      data,
      config,
    );
    return response.data;
  }

  /** Untag (unfavorite) a resource for the current user. Idempotent. */
  async remove(
    params: {
      resourceType: ResourceTagResourceType;
      resourceId: string;
      tagKey?: string;
    },
    config?: AxiosRequestConfig,
  ): Promise<void> {
    const organizationId = await this.client.getOrgID();
    const userId = await this.client.getUserID();

    await this.client.axios.delete(
      route(ENDPOINTS.DELETE, {
        organization_id: organizationId,
        user_id: userId,
        resource_type: params.resourceType,
        resource_id: params.resourceId,
        tag_key: params.tagKey ?? RESOURCE_TAG_FAVORITE,
      }),
      config,
    );
  }
}
